import { FormattedMessage, useIntl } from 'react-intl';
import { Container } from 'reactstrap';
import { parseLocale, type Locale } from '../../utils/intl/locale';
import s from './SmallFooter.module.scss';

interface SmallFooterLink {
  targets: Record<Locale, string>;
  i18n: string;
}

interface SmallFooterProps {
  links: SmallFooterLink[];
}

function SmallFooter({ links }: SmallFooterProps) {
  const intl = useIntl();
  const locale = parseLocale(intl.locale);

  const date = new Date();
  const currentYear = date.getFullYear();

  const renderedLinks = links.map((link) => (
    <a
      key={link.i18n}
      className={s.link}
      id={`__test-link_${link.i18n}`}
      href={link.targets[locale]}
    >
      <FormattedMessage id={link.i18n} />
    </a>
  ));

  return (
    <div className={s.smallFooter}>
      <Container>
        <div className={s.footerContent}>
          <div className={s.copyright}>
            © VERBUND Energy4Business GmbH {currentYear}
          </div>
          <div className={s.linksWrapper}>{renderedLinks}</div>
        </div>
      </Container>
    </div>
  );
}

export default SmallFooter;
